import axios from 'axios';
import { authService } from 'services/auth/auth_service';

const BASE_API_URL = process.env.REACT_APP_URL_API ?? '';
const API_URL = BASE_API_URL + '/users/validity';

export interface FileEntity {
  uuid: string;
  originalName?: string;
  mimeType?: string;
  size?: number;
  // ...outros campos que seu FilesFileEntity expõe
}


export const getValidity = async (uuid: string): Promise<any> => {
  const response = await axios.get<any>(`${API_URL}/?userUuid=${uuid}`);
  return response.data;
};

export const addValidity = async (data: any): Promise<any> => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.post<any>(`${API_URL}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const editValidity = async (uuid: string, data: any): Promise<any> => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.patch<any>(`${API_URL}/${uuid}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const approveValidity = async (uuid: string): Promise<any> => {
  const token = authService.getTokenAPIInterna();
  const response = await axios.put<any>(`${API_URL}/approve/${uuid}`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const getValidityFile = async (validityUuid: string): Promise<FileEntity> => {
  const token = authService.getTokenAPIInterna();
  const { data } = await axios.get<FileEntity>(`${API_URL}/file/${validityUuid}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

